jQuery(document).ready(function ($) {
  $(".js-modal-toggle").on("click", function (e) {
    e.preventDefault(); // console.log('Clicked');

    var $modalId = $(this).attr("data-modal-id");
    var $modal = $("#" + $modalId); // toggle modal & overlay
    // $modal.addClass("boom");

    $modal.parent().removeClass("is-closing");
    $modal.parent().addClass("is-active"); // $modal.removeClass("is-active");

    $modal.parent().siblings().removeClass("is-active");
    $("html, body").addClass("modal-active"); // console.log(modalId);
  }); // function modalOverlayClose() {
  //   $(".c-person-overlay").on("click", function (e) {
  //     var modalId = $(this)
  //       .closest(".c-person__container")
  //       .attr("data-modal-id");
  //     var $modal = $("#modal_" + modalId);
  //     //console.log(modalId);
  //     $modal.parent().addClass("is-closed", "out");
  //     $modal.addClass("is-closed", "out");
  //     $modal.siblings().addClass("is-closed", "out");
  //   });
  // }
  // modalOverlayClose();

  $(".c-person-modal__close").on("click", function (e) {
    var modalDataId = $(this).closest(".c-person-modal__container").attr("data-modal-id");
    var modal = $("#" + modalDataId);
    modal.parent().addClass("is-closing");
    modal.parent().removeClass("is-active");
    $("html, body").removeClass("modal-active");
  });
});